import React from 'react';
import { merge } from 'lodash';
import PropTypes from 'prop-types';
import { IconButton, TooltipHost, DirectionalHint, TooltipDelay } from 'office-ui-fabric-react';
import { useId } from '@uifabric/react-hooks';
import styles from './Callout.style';

const Callout = ({ content, styleOverride, directionalHint }) => {
  const tooltipId = useId('tooltip');
  const mergedStyles = merge({}, styles, styleOverride);

  return (
    <TooltipHost
      content={content}
      id={tooltipId}
      closeDelay={500}
      delay={TooltipDelay.zero}
      directionalHint={directionalHint}
      calloutProps={mergedStyles.callout}
      tooltipProps={mergedStyles.tooltip}
      styles={mergedStyles} // this is for the icon button
    >
      <IconButton iconProps={{ iconName: 'Info' }} aria-describedby={tooltipId} ariaLabel="Info" />
    </TooltipHost>
  );
};

Callout.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  directionalHint: PropTypes.number,
  styleOverride: PropTypes.shape({
    root: PropTypes.shape({}),
    callout: PropTypes.shape({}),
    tooltip: PropTypes.shape({}),
  }),
};

Callout.defaultProps = {
  content: '',
  directionalHint: DirectionalHint.topCenter,
  styleOverride: {},
};

export default Callout;
